export const findReplaceTranslationKey = (
    name: string | undefined,
    fallback: string
): string => {
    if (name && name.includes('variables.')) {
        return name.replace('variables.', 'variables_replace.');
    } else {
        return fallback;
    }
};